import { AppSettings } from '../configs/app.settings';

export class Log {
    static write(level: LogLevel = LogLevel.Debug, message: any, ...data: any) {

        if (!AppSettings.isProduction || level !== LogLevel.Debug) {

            let baseMessage = `[${new Date().toISOString()}] ${LogLevel[level]} `;

            // if not production, get the caller function name
            if (!AppSettings.isProduction) {
                try {
                    throw new Error();
                } catch (e) {
                    const stack = e.stack.split('\n');
                    let caller = stack[2].trim();
                    if (caller.indexOf('Log.') > -1) {
                        caller = stack[3].trim();
                    }
                    // we just want the function name
                    const hasFuncName = caller.indexOf(' (') > -1;
                    const funcName = (hasFuncName) ?
                        caller.substring(caller.indexOf('at ') + 3, caller.indexOf(' (')) :
                        caller.substring(caller.indexOf('at ') + 3);
                    baseMessage += `- ${funcName}`;
                }
            }
            baseMessage += ':';

            if (typeof message === 'string') {
                baseMessage += ' ' + message;
            }

            switch (level) {
                case LogLevel.Debug:
                    console.log(baseMessage, ...data);
                    break;
                case LogLevel.Info:
                    console.warn(baseMessage, ...data);
                    break;
                case LogLevel.Error:
                    console.error(baseMessage, ...data,);
                    break;
            }
        }
    }

    static debug(message: any, ...data: any) {
        this.write(LogLevel.Debug, message, ...data);
    }

    static error(message: any, ...data: any) {
        this.write(LogLevel.Error, message, ...data);
    }

    static info(message: any, ...data: any) {
        this.write(LogLevel.Info, message, ...data);
    }
}

export enum LogLevel {
    Debug = 0,
    Info = 1,
    Error = 2,
}
